'use client';

import { usePostHog } from 'posthog-js/react';
import { useEffect, useState } from 'react';

import { createSupabaseBrowserClient } from '@/lib/supabase/client';
import { PosthogEventKeys } from '@/constants/posthog-events';

import { TUserIdentify } from '@/types/posthog';

export default function Identify() {
  const posthog = usePostHog();
  const supabase = createSupabaseBrowserClient();
  const [user, setUser] = useState<TUserIdentify | null>(null);

  useEffect(() => {
    const { data } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session?.user) {
        setUser({
          email: session.user.email,
          id: session.user.id,
          first_name: session.user.user_metadata.first_name,
          last_name: session.user.user_metadata.last_name,
          user_type: session.user.user_metadata.user_type,
        });
      } else if (event === 'SIGNED_OUT') {
        posthog.reset();
        window.location.replace('/auth/login');
      }
    });

    return () => {
      data.subscription.unsubscribe();
    };
  }, [posthog, supabase]);

  useEffect(() => {
    if (user?.id && user?.email) {
      posthog.identify(user.id, {
        email: user.email,
        user_type: user.user_type,
        first_name: user.first_name,
        last_name: user.last_name,
      });
      posthog.capture(PosthogEventKeys.LOGIN, { email: user.email });
    }
  }, [user?.id, user?.email, posthog]);

  return null;
}
